import Vue from 'vue';
import App from './App.vue';
import router from './router';
import VueGtm from 'vue-gtm';
import 'core-js/fn/array/find';
import 'core-js/fn/array/fill';
import 'core-js/fn/object/assign';
import 'core-js/fn/promise';
import 'whatwg-fetch';
import 'element-ui/lib/theme-default/icon.css'; // only include the icon css
import Autocomplete from 'v-autocomplete';

Vue.use(Autocomplete);
Vue.use(VueGtm, {vueRouter: router});
Vue.config.productionTip = false;

new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {App}
});



// WEBPACK FOOTER //
// ./src/main.ts